import { createSelector } from '@reduxjs/toolkit';
import { undoableSelector } from "../clientSettings";
export const pastSelector = ({
  past
}) => past;
export const presentSelector = ({
  present
}) => present;
export const futureSelector = ({
  future
}) => future;
export const standardEntitiesSelector = ({
  entities
}) => entities;
export const undoableEntitiesSelector = createSelector(standardEntitiesSelector, presentSelector);
export const entitiesSelector = createSelector(undoableSelector, standardEntitiesSelector, undoableEntitiesSelector, (undoableClient, standard, undoable) => {
  return undoableClient ? undoable : standard;
});